export const hasMutation = (content, language) => {
  const header = content.header;
  if (header[language]) {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/modules/ReferenceList/utils.js